// extracted by mini-css-extract-plugin
export var statItem = "_dt-1";
export var statsRow = "_dt-0";